<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12" v-if="!cadastroProduto">
        <v-data-table
          :search="search"    
          :headers="headersProd"
          :items="produtos"
          class="elevation-1"
          style="border-radius: 10px;"
        >
          <template v-slot:item.urlImagem="{ item }">
            <v-img :src="item.urlImagem" max-width="70px"></v-img>
          </template>
          <template v-slot:item.status="{ item }">
            <p>{{item.status == "true" ? 'Ativo' : 'Inativo'}}</p>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">Produtos</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="cadastroProduto=true" tile color="#00253E">
                <v-icon left dark>add_circle</v-icon> Adicionar Produto
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItemProd(item)">edit</v-icon>
            <v-icon small @click="deleteItemProd(item)">delete</v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="#94AAB4" @click="carregaDados">Recarregar</v-btn>
          </template>
        </v-data-table>
      </v-col>

      <!-- CARD INSERE Produtos -->
      <v-col ls="12" sm="12" md="12" lg="12" v-else>
        <v-card  style="border-radius: 10px;">
          <v-card-title>
            <span class="textoUser">{{ formTitleProd }}</span>
            <v-spacer></v-spacer>
            <p style="font-size:15px; color:#94AAB4"> *O preenchimento de todos os campos é obrigatório</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="produto.codigo" outlined label="Código" color="#94AAB4" hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="produto.ordem" outlined label="Ordem" color="#94AAB4" hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-select v-model="produto.categoriaId" outlined label="Categoria" color="#7B1FA2" :items="categorias" hide-details item-text="descricao" item-value="id"></v-select>
                </v-col> 
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="produto.descricao" outlined label="Descrição" color="#94AAB4" hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field v-model="produto.preco" prefix="R$" outlined label="Preço" color="#94AAB4" hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="8">
                  <v-text-field v-model="produto.detalhes" outlined label="Detalhes" color="#94AAB4" hide-details></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="12" md="2">
                  <v-switch
                    v-model="produto.status"
                    :label="`ATIVO`"
                    color="#00253E"
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="5">
                  <v-card outlined>
                    <v-img v-if="produto.urlImagem" height="250" :src="produto.urlImagem"></v-img>
                    <v-sheet v-else height="250" outlined width="100%">
                      <v-alert class="text-center" v-if="!produto.urlImagems" dark dense outlined :value="true" color="#00253E" type="info">Nenhuma imagem anexada</v-alert>
                    </v-sheet>
                    <v-card-title>Imagem</v-card-title>
                    <v-card-actions>
                      <v-btn v-if="!produto.urlImagem" color="#00253E" text @click="uploadPhoto = true">Selecionar</v-btn>
                      <v-btn v-else color="#00253E" text @click="uploadPhoto = true">Alterar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#00253E" class="cssBotao" dark large @click="saveProduto">Salvar</v-btn>
            <v-btn color="#94AAB4" max-width="" class="cssBotao" large dark @click="closeProduto">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="uploadPhoto" max-width="550px" max-height="300px" persistent>
      <v-toolbar color="#00695C" dark dense>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="uploadPhoto = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card style="border-radius-bottom: 10px;">
        <v-container grid-list-md>
          <v-layout row wrap justify-center>
            <v-container fill-height fluid pa-1 justify-center>
              <vue-anka-cropper
                :options="{
                  aspectRatio: 1,
                  closeOnSave: true,
                  cropArea: 'box',
                  croppedHeight: 500,
                  croppedWidth: 500,
                  cropperHeight: false,
                  dropareaMessage: 'Arraste uma imagem aqui ou use o botão abaixo',
                  frameLineDash: [0,0],
                  frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
                  handleFillColor: 'rgba(255, 255, 255, 0.2)',
                  handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
                  handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
                  handleSize: 10,
                  handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
                  layoutBreakpoint: 500,
                  maxCropperHeight: 768,
                  maxFileSize: 8000000,
                  overlayFill: 'rgba(0, 0, 0, 0.5)',
                  previewOnDrag: false,
                  previewQuality: 0.65,
                  resultQuality: 0.8,
                  resultMimeType: 'image/jpeg',
                  selectButtonLabel: 'Escolher imagem',
                  showPreview: false,
                  skin: 'light',
                  uploadData: {},
                  uploadTo: false
                }"
                @cropper-error="erroCorte($event)"
                @cropper-saved="salvarCorte($event)"
                @cropper-cancelled="cancelaCorte()"
              ></vue-anka-cropper>
            </v-container>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import vueAnkaCropper from 'vue-anka-cropper'
  export default {
    components: {Snackbar,vueAnkaCropper},
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      addUser: false,
      dialog: false,
      cadastroCategoria: false,
      cadastroProduto: false,
      configAccess: false,
      headersProd: [
        { text: 'Código', value: 'codigo', align: 'start' },
        { text: 'Categoria', value: 'categoria.descricao' },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Detalhes', value: 'detalhes' },
        { text: 'Preço', value: 'preco' },
        { text: 'Status', value: 'status' },
        { text: 'Imagem', value: 'urlImagem' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      headersCat: [
        { text: 'Descrição', value: 'descricao' },
        { text: 'Ações', value: 'action', sortable: false, align: "right" },
      ],
      perfis: [],
      editedIndexCat: -1,
      editedIndexProd: -1,
      produto: {
        descricao: "",
        detalhes: "",
        preco: "",
        status: "",
        urlImagem: "",
        codigo: "",
        empresaId: "",
        categoriaId: "",
        ordem: ""

      },
      produtoDefault: {
        descricao: '',
        detalhes: '',
        preco: '',
        status: '',
        urlImagem: '',
        codigo: '',
        empresaId: '',
        categoriaId: '',
        ordem: ''

      },
      produtos: [],
      categorias: [],
      events: [],
      uploadPhoto: false,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndexProd === -1 ? 'ADICIONAR NOVO PRODUTO' : 'EDITAR PRODUTO'
      },  
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
    },

    created () {
      this.carregaDados()
    },

    methods: {
      async carregaDados () {
        //console.log(this.companyobj)
          await axios.get(`${baseApiUrl}Produtos?filter={"where":{"empresaId":"${this.companyobj.id}"},"include":"categoria"}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(res => {
            this.produtos = res.data
          })
        
          await axios.get(`${baseApiUrl}Categorias?filter={"where":{"empresaId":"${this.companyobj.id}"}}&access_token=${sessionStorage.getItem('accToken')}`)
          .then(res => {
            this.categorias = res.data
          })        
      },

      openDialog() {
        this.dialog = true
      },

      editItemProd (item) {
        this.editedIndexProd = this.perfis.indexOf(item)
        this.produto = Object.assign({}, item)
        this.cadastroProduto = true
      },

      async deleteItemProd (item) {
        var r = confirm('Deseja realmente excluir o produto: ' + item.descricao + '?')
        if (r == true) {
          try {
            await axios.delete(`${baseApiUrl}Produtos/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
            this.carregaDados()
          } catch (error) {
            var vm;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }
      },

      closeProduto () {
        this.cadastroProduto = false
        setTimeout(() => {
          this.produto = Object.assign({}, this.produtoDefault)
          this.editedIndexProd = -1
        }, 300)
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async saveProduto() {
        if (this.produto.descricao != '') {
          try {
            this.produto.empresaId = this.companyobj.id
            delete this.produto.categoria
            let res = await axios.post(`${baseApiUrl}Produtos/replaceOrCreate/?access_token=${sessionStorage.getItem('accToken')}`, this.produto)  
            if (res.data != null) {
              var vm = this;
              this.closeProduto()
              this.carregaDados()
            }
          } catch (error) {
            vm = this;          
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }        
      },

      erroCorte (event) {
        this.events = []
        this.events.unshift({payload: event})
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350","Ocorreu um erro durante a edição da imagem" + event,"DESCULPE");
      },

      salvarCorte(event) {
        this.events = []
        this.events.unshift({payload: event})
        this.produto.urlImagem = event.croppedImageURI
        this.uploadPhoto = false
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
